import {useMemo} from 'react';
import {
  initApiConsumer,
  ApiConsumerError,
  ApiEndpointConsumerRequest,
} from '@urpi/consumer';
import {StandardApiError, UnknownApiEndpoint} from '@urpi/common';
import {ApiErrors} from '@integraciones_doc24/wehealthy-api/types/errors';
import {getBackEnd} from './backEndUrl';
import {rootApiGroup} from '@integraciones_doc24/wehealthy-api';
import {getCurrentToken} from '../reducer/store';

const backendUrl = getBackEnd();
const apiConsumer = initApiConsumer<ApiErrors.All>(
  `${backendUrl}/api`,
  rootApiGroup,
);

export const isApiConsumerError = (
  candidate: unknown,
): candidate is ApiConsumerError<StandardApiError | ApiErrors.All> =>
  candidate instanceof ApiConsumerError ||
  (candidate as any).constructor.name === 'ApiConsumerError';

const wrapRequestWithAccessToken = <
  TRequest extends ApiEndpointConsumerRequest<UnknownApiEndpoint>,
>(
  request: TRequest,
  getAccessToken: () => string | undefined,
  endpoint: UnknownApiEndpoint,
): TRequest => {
  const wrapped = ((params) => {
    _logger(endpoint);
    const accessToken = getAccessToken();
    return request(params, {
      headers: {
        authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    });
  }) as TRequest;

  return wrapped;
};

const _logger = (endpoint: UnknownApiEndpoint) =>
  console.log(endpoint.method, endpoint.name);

export const useApiRequest = <TEndpoint extends UnknownApiEndpoint>(
  endpoint: TEndpoint,
) => {
  const request: ApiEndpointConsumerRequest<TEndpoint> = useMemo(() => {
    const baseRequest = apiConsumer(endpoint);
    return wrapRequestWithAccessToken(baseRequest, getCurrentToken, endpoint);
  }, [endpoint]);

  return request;
};
